import type { FunctionComponent } from 'react';
import { Button } from '@george-labs.com/design-system';
import type { ButtonProps } from '@george-labs.com/design-system/types/components/Button/NewButton';

export const DevToolsButton: FunctionComponent<ButtonProps> = (passThroughProps) => (
    <section>
        <Button
            className="justify-content-start"
            variant={Button.VARIANT.TERTIARY}
            size={Button.SIZE.SMALL}
            fullWidth={Button.FULL_WIDTH.ALWAYS}
            {...passThroughProps}
        />
    </section>
);
